import { Billboard, Text } from "@react-three/drei"
import { Suspense, type ComponentProps } from "react"

type TextProps = ComponentProps<typeof Text>

export function SceneText(props: TextProps) {
  return (
    <Suspense fallback={null}>
      <Billboard>
        <Text
          fontSize={0.16}
          anchorX="center"
          anchorY="middle"
          color="#f2f5f4"
          characters="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.'%-/: "
          {...props}
        />
      </Billboard>
    </Suspense>
  )
}
